import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SuperTableAddRow } from '../../../../enums/super-table-add-row.enum';

@Component({
    selector: 'add-row',
    templateUrl: './add-row.component.html',
    styleUrls: ['./add-row.component.scss'],
})
export class AddRowComponent {
    @Output() selectedOption: EventEmitter<SuperTableAddRow> = new EventEmitter<SuperTableAddRow>();

    /** FX (REV-21512): rate-row options are offered only on FX reports. */
    @Input() fxEnabled = false;

    superTableAddRow = SuperTableAddRow;

    selectOption(option: SuperTableAddRow): void {
        this.selectedOption.emit(option);
    }
}
